module.exports = __webpack_public_path__ + "img/icon_home_ai_icon_11.ec7fc0da.png";